<a class="Favorites" [ngClass]="{'Favorites--selected': isFavoriteDoc}" (click)="toggleFavorite()">
    <span class="Add" matTooltip="Add to favorites" matTooltipPosition="below"></span>
    <span class="Remove" matTooltip="Remove from favorites" matTooltipPosition="below"></span>
</a>